import styled from '@emotion/styled';

const DescriptionWrapper = styled('div')(
  {
    position: 'absolute',
    top: 9,
    right: 9,
    cursor: 'help'
  },
  ({ theme }) => ({
    color: theme.palette.colors.dodgerBlue
  })
);

export default DescriptionWrapper;
